import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRCON_AUT;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
